<template>
  <section class="login-page">
    <!-- Same width as the quick quote panel, so the two sign-in screens match. -->
    <div class="login-page-container">
      <LoginStep :redirect-url="redirectUrll" />
    </div>
  </section>
</template>

<script>
import LoginStep from '@/components/auth/LoginStep'
import { buildSocialMeta } from '@/helpers/social-meta'

const CANONICAL_PATH = '/login'

export default {
  name: 'LoginPage',
  components: { LoginStep },
  data() {
    return {
      redirectUrll: '/dashboard',
    }
  },
  head() {
    const title = 'Login Page | PedalSure'
    const description = 'Pedalsure Login Page'
    return {
      title,
      meta: [
        { hid: 'description', name: 'description', content: description },
        ...buildSocialMeta({
          title,
          description,
          path: CANONICAL_PATH,
        }).meta,
      ],
    }
  },
  mounted() {
    // this.$store.dispatch('user/logout')
    if (this.$route.query.nextUrl) {
      this.redirectUrll = this.$route.query.nextUrl
    }
  },
}
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  justify-content: center;
  padding: 24px 15px 40px;
  font-family: $family-regular;

  @include tablet {
    padding: 48px 20px 64px;
  }
}
.login-page-container {
  width: 100%;
  max-width: 460px;
}
</style>
